module.exports = __webpack_public_path__ + "img/img-attendances-index.a8b03186.png";